/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MashtabTariff {
    START = 'start',
    MASHTAB = 'mashtab',
    PLATINA = 'platina',
    VIP = 'vip',
    EASY_START = 'easy_start',
}
